import {
  LEGAL_FORM_DEPOSIT_TAKER,
  LEGAL_FORM_ISSUER_ENTITY,
  LEGAL_FORM_LEGAL_FORM_TYPE,
  LEGAL_FORM_LEGAL_PROGRAMME
} from './product-capture-field-selectors.consts';

import { FCSelector } from '../../model/form-config.interface';

export const LEGAL_FORM_TYPE: FCSelector = {
  formControlNames: [
    LEGAL_FORM_LEGAL_FORM_TYPE,
  ],
  options: [
    {
      id: 'DEPOSIT',
      label: 'Deposit',
      logic: 'EXCLUDE',
      effects: [
        {
          formControlNames: [LEGAL_FORM_DEPOSIT_TAKER],
          hidden: true,
        },
      ],
    },
    {
      id: 'DEPOSIT',
      label: 'Deposit',
      logic: 'INCLUDE',
      effects: [
        {
          formControlNames: [LEGAL_FORM_DEPOSIT_TAKER],
          hidden: false,
        },
      ],
    },
    {
      id: 'OTC',
      logic: 'INCLUDE',
      effects: [
        {
          formControlNames: [
            LEGAL_FORM_LEGAL_PROGRAMME,
            LEGAL_FORM_ISSUER_ENTITY,
          ],
          hidden: true,
        },
      ],
    },
    {
      id: 'OTC',
      logic: 'EXCLUDE',
      effects: [
        {
          formControlNames: [
            LEGAL_FORM_LEGAL_PROGRAMME,
            LEGAL_FORM_ISSUER_ENTITY,
          ],
          hidden: false,
        },
      ],
    },
  ],
};
